import { Container, ContainerProps } from '@mui/material'
import styled from '@emotion/styled'
type CoreContainerProps = {
  unused?: boolean
}
const CoreContainer = styled(Container)<CoreContainerProps & ContainerProps>`
  max-width: ${({ unused }) =>
    unused ? 'none !important' : '1440px !important'};
  padding-left: ${({ unused }) => (unused ? '0px' : '16px')};
  padding-right: ${({ unused }) => (unused ? '0px' : '16px')};

  @media screen and (min-width: 1280px) {
    padding-left: ${({ unused }) => (unused ? '0px' : '50px')};
    padding-right: ${({ unused }) => (unused ? '0px' : '50px')};
  }
`

export default CoreContainer
